import { Fade } from "react-awesome-reveal";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { formatUrl } from "../exports/functions";
import useMobile from "../hooks/useMobile";
import useTab from "../hooks/useTab";
import DynamicToolTip from "./DynamicToolTip";
import sciever from "../images/ScieverInc.jpg";
// import logo from "../assets/images/frcsit-logo.png";

const Footer = () => {
  const mobile = useMobile();
  const tab = useTab();
  const { companyDetailsData } = useCompanyDetailsContext();

  return (
    <footer className="site-footer">
      {/* <div
        className="site-footer-bg"
        style={{
          backgroundImage: `url(${logo})`,
        }}
      ></div> */}
      <div className="site-footer__top">
        <div className="container">
          <div className="row">
            <div
              className="col-xl-6 col-lg-12 col-md-12 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <Fade cascade damping={0.2} triggerOnce={true}>
                <div className="footer-widget__column footer-widget__about">
                  <div className="footer-widget__about-text-box">
                    <img
                      height={mobile ? "40" : tab ? "60" : "80"}
                      src={
                        companyDetailsData[0]?.logo[0]?.media?.url
                          ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.logo[0]?.media?.url}`
                          : undefined
                      }
                      alt="logo"
                    />
                    <p className="footer-widget__about-text-description">
                      The FRCSIT is a non-profit medical educational and
                      charitable trust formed in Asia. The body is dedicated to
                      the development of plastic and reconstructive surgery of
                      the head, face, and neck in India.
                    </p>
                  </div>
                  {/* <a href="/about" className="donate-btn footer-donate__btn">
                  {" "} */}
                  {/* <i className="fa fa-heart"></i> */}
                  {/* Know More */}
                  {/* </a> */}
                  <div className="welcome-one__btn-box">
                    <a href="/about" className="thm-btn welcome-one__btn">
                      Know More
                    </a>
                  </div>
                </div>
              </Fade>
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="400ms"
            >
              <Fade cascade damping={0.2} delay={200} triggerOnce={true}>
                <div className="footer-widget__column footer-widget__contact clearfix">
                  <h3 className="footer-widget__title">Contact</h3>
                  <ul className="list-unstyled footer-widget__contact-list">
                    <li>
                      <div className="icon">
                        <span className="icon-pin"></span>
                      </div>
                      <div className="text">
                        <p>{companyDetailsData[0]?.company_address}</p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-telephone"></span>
                      </div>
                      <div className="text">
                        <a href={`tel:${companyDetailsData[0]?.phone_number}`}>
                          {companyDetailsData[0]?.phone_number}
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <span className="icon-email"></span>
                      </div>
                      <div className="text">
                        <a href={`mailto:${companyDetailsData[0]?.email}`}>
                          {companyDetailsData[0]?.email}
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </Fade>
            </div>
            <div
              className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <Fade cascade damping={0.2} delay={400} triggerOnce={true}>
                <div className="footer-widget__column footer-widget__links clearfix">
                  <h3 className="footer-widget__title">Social Media</h3>
                  {/* <ul className="footer-widget__links-list list-unstyled clearfix">
                  <li>
                    <a href="donations.html">Recent Causes</a>
                  </li>
                  <li>
                    <a href="about.html">About us</a>
                  </li>
                  <li>
                    <a href="events.html">New Campaign</a>
                  </li>
                  <li>
                    <a href="about.html">Site Map</a>
                  </li>
                  <li>
                    <a href="events.html">Events</a>
                  </li>
                </ul> */}
                  <div className="site-footer__social">
                    {companyDetailsData[0]?.twitterx_link !== null && (
                      <DynamicToolTip title="TwitterX">
                        <a
                          href={formatUrl(companyDetailsData[0]?.twitterx_link)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="icon-x"></i>
                        </a>
                      </DynamicToolTip>
                    )}
                    {companyDetailsData[0]?.facebook_link !== null && (
                      <DynamicToolTip title="Facebook">
                        <a
                          href={formatUrl(companyDetailsData[0]?.facebook_link)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="fab fa-facebook"></i>
                        </a>
                      </DynamicToolTip>
                    )}
                    {companyDetailsData[0]?.instagram_link !== null && (
                      <DynamicToolTip title="Instagram">
                        <a
                          href={formatUrl(
                            companyDetailsData[0]?.instagram_link,
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </DynamicToolTip>
                    )}
                    {companyDetailsData[0]?.linkedin_link !== null && (
                      <DynamicToolTip title="LinkedIn">
                        <a
                          href={formatUrl(companyDetailsData[0]?.linkedin_link)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="icon-linkedin"></i>
                        </a>
                      </DynamicToolTip>
                    )}
                    {companyDetailsData[0]?.tiktok_link !== null && (
                      <DynamicToolTip title="Tiktok">
                        <a
                          href={formatUrl(companyDetailsData[0]?.tiktok_link)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="icon-tiktok"></i>
                        </a>
                      </DynamicToolTip>
                    )}
                  </div>
                </div>
              </Fade>
            </div>
            {/* <div
              className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay="300ms"
            >
              <div className="footer-widget__column footer-widget__non-profit clearfix">
                <h3 className="footer-widget__title">Non Profit</h3>
                <ul className="footer-widget__non-profit-list list-unstyled clearfix">
                  <li>
                    <a href="differently-abled-kids.html">
                      Differently Abled Kids
                    </a>
                  </li>
                  <li>
                    <a href="help-child-cancer.html">Help Child Cancer</a>
                  </li>
                  <li>
                    <a href="clean-pure-water.html">Clean Pure Water</a>
                  </li>
                  <li>
                    <a href="give-them-education.html">Give them Education</a>
                  </li>
                  <li>
                    <a href="start-a-fundraising.html">Start a Fundraising</a>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="site-footer__bottom-inner">
                <p
                  className="site-footer__bottom-text"
                  style={{ textAlign: mobile ? "center" : "unset" }}
                >
                  © Copyright {new Date().getFullYear()}{" "}
                  <a href="/">{companyDetailsData[0]?.company_name} </a>-
                  Powered by{" "}
                  <a
                    href="https://www.scieverinc.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={sciever}
                      alt="sciever-img"
                      style={{ margin: "0px 4px 5px 0px" }}
                    />
                    Sciever Inc.
                  </a>
                </p>
                {/* <div className="site-footer__social">
                  <a href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-pinterest-p"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
